let serviceURI;

export const getServiceURI = () => serviceURI;

export const setServiceURI = (uri) => {
  serviceURI = uri;
};
